
import React, { useState, useEffect } from 'react';
import moment from "moment";
import { FuncionarioDados, ContrachequeEntidade, FichaFinanceiraAssistidoEntidade } from '../../../entidades';
import { Alert, Box } from '@intech/web-ui';

import { LoadingComponent } from '../../../components/LoadingComponent';

import { Header } from './Header';
import { Item } from './Item';
import { Table } from './styles';

interface IProps {
  lista: Array<FichaFinanceiraAssistidoEntidade>,
  CdPlano: string;
}

export const Lista: React.FC<IProps> = ({
  lista,
  CdPlano
}) => {
  const [AlertText, setAlertText] = useState<string>("");
  const [Lista, setlista] = useState<Array<FichaFinanceiraAssistidoEntidade>>();

  useEffect(() => {
    (async () => {
      try {
        setlista(lista);
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        console.log(error);
        setAlertText(error);
      }

    })();
  }, []);

  function renderLista() {
    if (Lista !== undefined) {
      if (Lista.length > 0) {
        const Itens = Lista.map((valor: FichaFinanceiraAssistidoEntidade, index: number) => {
          const Data = moment(valor.DT_REFERENCIA, "DD/MM/yyyy").format("DD.MM.yyyy");
          const textoLink = `${CdPlano}/${Data}/${valor.CD_TIPO_FOLHA}/${valor.CD_ESPECIE}` + (valor.PREVIA ? "/previa" : "");
          return (
            <Item key={index} item={valor} textoLink={textoLink} />
          );
        });

        return (
          <div className={"table-responsive"}>
            <table className={"table table-striped table-sm"}>
              <Header />

              <tbody>
                {Itens}
              </tbody>

            </table>
          </div>
        );
      }

      if (Lista.length === 0) {
        return (
          <Alert type={"danger"}>{"Nenhum contracheque disponível para este plano."}</Alert>
        );
      }
    }

    return <LoadingComponent />
  }

  return renderLista();
}
